import React, {useState} from "react";
import DropdownIndicatorIcon from "./DropdownIndicatorIcon";

const DropdownToggle = React.forwardRef(({children, onClick, toggle, Icon}, ref) => {

    var Icon = Icon ?? DropdownIndicatorIcon;

    return (
        <button
            className="btn react-select-button"
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className="react-select-placeholder-button">
                {children}
            </div>
            <div className="react-select-indicator-button">
                <Icon status={toggle}/>
            </div>
        </button>
    )
});

export default DropdownToggle;
